import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Lock } from "@air/next-icons";
import { memo } from "react";
import { getKeyForShortIDVerificationStatus } from "~/utils/SessionHelpers";
import { PasswordPageBackground } from "./PasswordPageBackground";
import { PasswordPageHeader } from "./PasswordPageHeader/PasswordPageHeader";
import { PasswordPageInput } from "./PasswordPageInput/PasswordPageInput";
export const PasswordPage = /*#__PURE__*/ memo((param)=>{
    let { shortId, onVerified } = param;
    const onVerifiedHandler = async ()=>{
        window.sessionStorage.setItem(getKeyForShortIDVerificationStatus(shortId), "verified");
        await onVerified();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex h-screen items-center justify-center overflow-hidden",
        children: [
            /*#__PURE__*/ _jsx(PasswordPageBackground, {}),
            /*#__PURE__*/ _jsx(PasswordPageHeader, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "m-auto w-full max-w-[350px] p-6",
                children: [
                    /*#__PURE__*/ _jsx(Lock, {
                        className: "ml-[-5px] w-8 text-grey-10"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-6 text-24 font-semibold text-grey-12",
                        children: "This link is private"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-4 text-16 text-grey-11",
                        children: "Please enter the passcode to view"
                    }),
                    /*#__PURE__*/ _jsx(PasswordPageInput, {
                        shortId: shortId,
                        onVerified: onVerifiedHandler
                    })
                ]
            })
        ]
    });
});
PasswordPage.displayName = "PasswordPage";
